<div class="panel panel-font gradient-bg">
  <span class="panel-title">{{ 'Vyhledání kontaktního místa' | translate}}</span>
  <a [routerLink]="'/'" class="closeBtn" title="{{ 'zavřít' | translate }}"></a>

  <app-search-input [inputData]="state.searchText" [placeholder]="'Název místa...'" (search)="onSearch($event)" />

  <div *ngIf="loading">
    <app-loading></app-loading>
  </div>

  <div class="panel-subtitle mt4" *ngIf="state.searchedPlaces.length == 0 && term && !loading">
    {{ 'Nebylo nalezeno kontaktní místo s tímto názvem.' | translate }}
  </div>

  <div *ngIf="!loading">
    <ul class="mainList">
      <li *ngFor="let place of state.searchedPlaces">
        <div class="panel-section clickable clickable-list" (click)="contactClick(place)" (keyup.enter)="contactClick(place)">
          <div class="d-flex">
            <div class="iconKM iconDiv">
              <span></span>
            </div>
            <div>
              <span class="h6">{{place.name}}</span>
              <div class="fw-light">{{place.operator}}</div>
            </div>
          </div>
          <div class="panel-section-divider"></div>
          <div class="d-flex">
            <div class="description-icon">
              <img src="/img/contact-place/address.svg" alt="adresa" />
            </div>
            <div>
              {{place.adress}}
            </div>
            <div class="mla">
              <a *ngIf="!place.isExpanded" href="javascript:void(0)">Více...</a>
              <a *ngIf="place.isExpanded" href="javascript:void(0)">Méně...</a>
            </div>
          </div>

          <div *ngIf="place.remark.length > 0">{{place.remark}}</div>
          <div class="d-flex" *ngIf="place.isExpanded && place.phone">
            <div class="description-icon">
              <img src="/img/contact-place/phone.svg" alt="telefon" />
            </div>
            <div>
              tel.&nbsp;<a href="tel:{{place.phone}}">{{place.phone}}</a>
            </div>
          </div>

          <div class="d-flex" *ngIf="place.isExpanded && place.email">
            <div class="description-icon">
              <img src="/img/contact-place/email.svg" alt="email" />
            </div>
            <div>
              <a href="mailto:{{place.email}}">{{place.email}}</a>
            </div>
          </div>

          <div class="ml4" *ngIf="place.openingHours.length > 0 && place.isExpanded">
            {{ 'Otevřeno' | translate }}:
            <ul class="mainList">
              <li *ngFor="let hours of place.openingHours">
                @if (hours.from.length > 0 || hours.hours.length > 0) {
                <span>{{hours.from}}</span>
                <div>{{hours.hours}}</div>
                }
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
